import React from 'react';

import PropTypes from 'prop-types';
import { Box, StackView, Typography } from '@telus-uds/components-web';

import {
  Thead,
  Td,
  Tr,
  Th
} from '../orderDetailsSection/ratePlans/components/css';
import getFormattedPricing from '../orderDetailsSection/utils';

const SummaryAddons = ({ addons, total }) => {
  // Filter out zero-qty entries at render time. The raw `addons` map is
  // still persisted (BE uses partial-merge save, so previously-saved
  // addons need explicit qty:0 to be cleared); but the in-app summary
  // should only show add-ons the customer actually selected.
  const visibleAddons = Object.keys(addons).filter(
    item => addons[item] && Number(addons[item].quantity) > 0
  );
  if (visibleAddons.length === 0) return null;
  return (
    <>
      {Object.keys(addons).length > 0 && (
        <StackView space={3}>
          <Typography heading="h4" variant={{ size: 'h4' }} block>Add-ons</Typography>
          <table>
            <Thead>
              <Tr>
                <Th>Add-on</Th>
                <Th>Unit</Th>
                <Th>Unit Price</Th>
                <Th>Total monthly fee</Th>
              </Tr>
            </Thead>
            <tbody>
              {visibleAddons.map(addonName => {
                const { quantity, unitPrice } = addons[addonName];
                return (
                  <tr>
                    <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
                      {addonName}
                    </Td>
                    <Td>{quantity}</Td>
                    <Td>{getFormattedPricing(unitPrice)}</Td>
                    <Td>{getFormattedPricing(unitPrice * quantity)}</Td>
                  </tr>
                );
              })}
              <Tr style={{ background: '#f4f4f4' }}>
                <Td colSpan={3}>
                  <Typography variant={{ bold: true }}>Total</Typography>
                </Td>
                <Td>
                  <Typography variant={{ bold: true }}>{getFormattedPricing(total)}</Typography>
                </Td>
              </Tr>
            </tbody>
          </table>
        </StackView>
      )}
    </>
  );
};

SummaryAddons.propTypes = {
  addons: PropTypes.shape({
    quantity: PropTypes.number,
    unitPrice: PropTypes.number
  }).isRequired,
  total: PropTypes.number.isRequired
};

export default SummaryAddons;
